<template>
    <div class="preAlert">
        <div class="box-white-wrapper">
            
            <div class="form">
                <form name="form" @submit.prevent="searchPackage">
                  <div class="form-input"> 
                     <vs-select label="Nuevo Estado" v-model="newStatus">
                      <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in options1" />
                    </vs-select>
                  </div>
                  <div class="form-input">

                        <vs-input label="Número de tracking" v-model.trim="tracking"/>
                        <!-- <span class="error-text" v-if="$v.inventory.tracking.$error"><feather type="info" />Este campo es requerido</span> -->
                  </div>
                    
                    <div class="form-input">
                        <vs-button color="primary" type="border" icon="" id="btnPaid" class="vs-con-loading__container" :disabled="tracking != '' ? false : true" 
                                @click="searchPackage">Buscar</vs-button>
                    </div>
                </form>
                <vs-alert title="Tracking no encontrado" color="primary" active="true" v-if="notFound">
                    El tracking ingresado no fue encontrado
                </vs-alert>
            </div>
        </div>       
    </div>
</template>
<script>
//local registration
import { mapState } from 'vuex'
import {helper} from '@/helpers/utils'
import { Role } from '@/helpers/Role.js'
import 'v-credit-card/dist/VCreditCard.css'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import InventoryModel from "@/models/InventoryModel"
// import { required } from 'vuelidate/lib/validators' 
import InventoryService from "@/services/InventoryService"

export default {
  name: "PreAlertPacakge",
  mixins: [helper],
  data () {
    return {
       notFound: false,
       inventory: new InventoryModel(),
       tracking:"",
       options1: [
         {
           value : 10,
           text : "En Box Logistics"
         },
         {
           value : 11,
           text : "En Ruta"
         }
       ],
       newStatus : 10
    }
  },
  created(){
    this.Roles = Role
    if(this.Roles.Distribuitor === this.userInfoData.role){
        this.$router.push({ name: "packages"})
        this.$vs.notify({title:'Información!',text:'Acceso denegado!',color:'danger',icon:'error_outline'})
    }

  },
  computed: {
    ...mapState([
      'userInfoData'
    ]),
  },
  methods:{  
    searchPackage(){
        this.notFound = false
        // this.$v.$touch()
        // if (this.$v.$invalid) return;
        const that = this
        that.loadingProgress ('#btnPaid', '#1a426d')
        that.disabled = true
        InventoryService.changePkgStatus({
          id : this.tracking,
          st01Code: this.newStatus
        })
        .then(response => {
            that.disabled = false
            console.log(response)
            this.inventory = new InventoryModel();
            // this.$v.$reset();
            this.tracking = "";
            this.newStatus = 10;
            that.$vs.loading.close('#btnPaid .con-vs-loading')
            that.$vs.notify({title:'Información!',text:'El paquete fue actualizado exitosamente!',color:'success',icon:'check'})
        })
        .catch(e => {
            console.log(e)
            that.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
            that.disabled = false
            this.notFound = true
            that.$vs.notify({title:'Información!',text:'Paquete no encontrado',color:'danger',icon:'error_outline'})                
        });
           
    },
  }
}
</script>
